import styled from 'styled-components';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';

export const Container = styled.div`
  position: relative;
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_200};`)};
  ${dynamicStyling({
    alpha: `
        display: flex;
        flex-direction: column;
        `,
  })};
`;

export const StyledPagination = styled.div<{ isListView: boolean; pictureLength?: number }>`
  display: flex;
  justify-content: ${(props): string =>
    dynamicStylingHelper(props.isListView ? 'center' : 'flex-end', 'center')};
  ${(props): string =>
    props.pictureLength === undefined || props.pictureLength > 1
      ? `margin-top: ${dynamicStylingHelper(SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200)};`
      : `margin-top: 30px;`}
`;

export const Spacing = styled.div`
  min-height: 48px;
  width: 100%;
  visibility: hidden;
`;
